// extracted by mini-css-extract-plugin
export var typingIndicator = "_os-0";